import React, { useState } from "react";
import DisplayCell from "./DisplayCell";
import DataCtx from "./api/DataCtx";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ParameterPopover from "./ParameterPopover";
import { IParameter, parameterMap } from "./parametermapping";

const ncocLogo = new URL(
    'ncoc-logo-white.svg',
    import.meta.url
  );

const languages = {
    kk: { nativeName: 'QAZ'}, // Қазақша
    ru: { nativeName: 'РУС'}, // Русский
    en: { nativeName: 'ENG'}  // English
}

const Display = () => {

    const { t, i18n } = useTranslation();

    const data = React.useContext(DataCtx);

    const timezoneOffset = (new Date().getTimezoneOffset()) / 60 * (-1); // * (-1) due to the logic of getTimezoneOffset()
    const timezoneLabel = `UTC${timezoneOffset >= 0 ? '+' : ''}${timezoneOffset}`;

    const [selectedParameterId, setSelectedParameterId] = useState<number | undefined>(undefined);

    let dataTimestampMin = data.params.reduce((min, current) => 
        current.timestamp < min ? current.timestamp : min,
        Infinity
    );

    let dataTimestampMax = data.params.reduce((max, current) => 
        current.timestamp > max ? current.timestamp : max,
        -Infinity
    );

    // Get value of airTemperature to determine whether to show windChill or heatStress
    const airTemperatureParameter: IParameter = parameterMap.filter(parameter => parameter.label == "airTemperature")[0];
    const airTemperatureRecord = data.params.filter(p => p.id === airTemperatureParameter.id)[0]
    const airTemperatureValue = parseFloat(airTemperatureRecord.value)

    return (
        <>
            <div className="header" style={{ display: 'flex', justifyContent: 'space-between'}}>
                {/* Header text */}
                <div style={{ display: 'flex', flexDirection: 'column'}}>
                    <span>{t("title")}</span>
                    {
                        dataTimestampMin === dataTimestampMax 
                        ? 
                        <span style={{fontSize: "0.66em", fontWeight: 400}}>{t("subtitle")} {moment(dataTimestampMax).format("HH:mm DD/MM/YYYY")} [{timezoneLabel}]</span>
                        :
                        <span style={{fontSize: "0.66em", fontWeight: 400}}>{t("subtitle")} {moment(dataTimestampMin).format("HH:mm")} - {moment(dataTimestampMax).format("HH:mm DD/MM/YYYY")} [{timezoneLabel}]</span>    
                    }
                </div>
                {/* Buttons for language selection */}
                <div style={{ display: 'flex', justifyContent: 'center', marginRight: 'calc((33vw - 6 * 10px) / 2 - (44.89px + 44.05px + 46.67px) / 2)'}}>
                    {Object.keys(languages).map((language) => (
                        <button 
                            className={`language-menu-item ${i18n.resolvedLanguage === language? "active" : ""}`}
                            type="submit" 
                            key={language} 
                            onClick={() => i18n.changeLanguage(language)} 
                            disabled={i18n.resolvedLanguage === language}
                        >
                            {languages[language].nativeName}
                        </button>
                    ))}
                </div>
                {/* Logo */}
                <img className="logo" src={ncocLogo.href} alt="NCOC Logo" />
            </div>
            <div className="datagrid">
                <div className="datarow">
                    <DisplayCell parameterLabel={"windDirection"} compass={true} onClick={setSelectedParameterId} />
                    <DisplayCell parameterLabel={"windSpeed"}  onClick={setSelectedParameterId} />
                    <DisplayCell parameterLabel={"windGust"} onClick={setSelectedParameterId} />
                </div>
                <div className="datarow">
                    <DisplayCell parameterLabel={"airTemperature"} onClick={setSelectedParameterId} />
                    <DisplayCell parameterLabel={"relativeHumidity"} onClick={setSelectedParameterId} />
                    <DisplayCell parameterLabel={"airPressure"} onClick={setSelectedParameterId} />
                </div>
                <div className="datarow">
                    <DisplayCell parameterLabel={"waterLevel"} onClick={setSelectedParameterId} />
                    <DisplayCell parameterLabel={"waterDepth"} onClick={setSelectedParameterId} />
                    <DisplayCell parameterLabel={"waterTemperature"} onClick={setSelectedParameterId} />
                </div>
            </div>
            <div className="footer">
                {t("footer")}<br />
                {t("footer2")}
                <div className="disclaimer"><strong>{t("disclaimerTitle")}:</strong><br />{t("disclaimer")}</div>
            </div>
            {/* Render parameter plot as popover - if a parameter has been selected*/}
            {selectedParameterId &&
                <ParameterPopover 
                    selectedParameterId={selectedParameterId}
                    setSelectedParameterId={setSelectedParameterId}
                    timezoneLabel={timezoneLabel}
                />
            }
        </>
    );
};

export default Display;